import { render, staticRenderFns } from "./AlarmTypeUpdateModal.vue?vue&type=template&id=b01889ee&scoped=true&"
import script from "./AlarmTypeUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AlarmTypeUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./AlarmTypeUpdateModal.vue?vue&type=style&index=0&id=b01889ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01889ee",
  null
  
)

export default component.exports